export default __webpack_public_path__ + "static/media/pineNt1.c25c7402.png";